var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('FormUser',{attrs:{"addUser":_vm.updateUserById,"userData":_vm.userData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }